<template>
    <div class="popup-wrapper">
        <div class="popup-wrapper--container">
            <div class="popup popup-packeta">
                <div class="popup--close" @click="$emit('close')">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 5.0625L10 10.0625L5 15.0625" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M15 5.0625L10 10.0625L15 15.0625" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>

                <div class="popup--body" id="packeta-map"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        emits: ['close'],
        props: {
            cart: {
                type: Object
            }
        },
        mounted() {
            Packeta.Widget.pick('d67045dfedc2fd7c', pickupPoint => {
                
                if ( !pickupPoint ) return this.$emit('close')
                    
                return this.$emit('update', pickupPoint)

            }, {
                country: 'sk',
                language: 'sk'
            }, document.getElementById('packeta-map'))
        }
    }
</script>